/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/**
 * Render Testimonial Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data from api
 * @returns {ReactElement} - Testimonial Component
 */
const Testimonial = ({ sectionContent }) => {
  return (
    <Box
      bgColor={{ md: '#f5f0e5', base: 'transparent' }}
      m="19px auto 0 auto"
      p={{
        lg: '2rem calc((100% - 1120px) / 2)',
        md: '3rem 1rem',
        base: '2rem 1vw',
      }}
      display={{ lg: 'flex', md: 'block', sm: 'block', base: 'flex' }}
      // justifyContent="center"
      overflowX="hidden"
      overflowY="hidden"
    >
      <Box
        bgColor="#f5f0e5"
        p="0 20px"
        display={{ lg: 'flex', md: 'flex', sm: 'flex' }}
        textAlign="center"
        pt={{ lg: '0', md: '0', base: '20px' }}
        pb={{ lg: '0', md: '0', base: '20px' }}
        m={{
          xl: '0 3rem 1rem auto',
          lg: '0 0rem 1rem auto',
          md: '0 3rem 3rem auto',
          base: '0 10px',
        }}
        height="100%"
        minWidth={{ md: '50%', base: 'calc(100% - 52px)' }}
      >
        <LazyLoadImageComponent
          src={sectionContent?.testimonials[0]?.photo?.url}
          mr="1rem"
          height="170px"
          width="170px"
          borderRadius="50%"
        />
        <Box
          ml="auto"
          width={{ lg: '320px', md: '100%', sm: '100%' }}
          textAlign="left"
          lineHeight="29px"
          fontStyle="italic"
          pt={{ base: '10px' }}
          pl={{ md: '20px' }}
        >
          {sectionContent?.testimonials[0]?.testimonialText}
          <br />
          <Text
            fontWeight="bold"
            pt={{ lg: '16px', md: '16px', base: '32px' }}
            fontStyle="normal"
          >
            {sectionContent?.testimonials[0]?.userName}
          </Text>
        </Box>
      </Box>
      <Box
        bgColor="#f5f0e5"
        p="0 20px"
        display={{ lg: 'flex', md: 'flex', sm: 'flex' }}
        textAlign="center"
        pt={{ lg: '0', md: '0', base: '20px' }}
        pb={{ lg: '0', md: '0', base: '20px' }}
        m={{
          xl: '0 3rem 1rem auto',
          lg: '0 0rem 1rem auto',
          md: '0 3rem 3rem auto',
          base: '0 10px',
        }}
        height="100%"
        minWidth={{ md: '50%', base: 'calc(100% - 52px)' }}
      >
        <LazyLoadImageComponent
          src={sectionContent?.testimonials[1]?.photo?.url}
          mr="1rem"
          height="170px"
          width="170px"
          borderRadius="50%"
        />
        <Box
          ml="auto"
          width={{ lg: '320px', md: '100%', sm: '100%' }}
          textAlign="left"
          lineHeight="29px"
          fontStyle="italic"
          pt={{ base: '10px' }}
          pl={{ md: '20px' }}
        >
          {sectionContent?.testimonials[1]?.testimonialText}
          <br />
          <Text
            fontWeight="bold"
            pt={{ lg: '16px', md: '16px', base: '32px' }}
            fontStyle="normal"
          >
            {sectionContent?.testimonials[1]?.userName}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Testimonial;
